function PriceListItemMeedyVO(id, pricelist, offer, def, customAppointmentLength, price, kickback, idInsurer) {

    this.id = id;
    this.pricelist = pricelist;
    this.offer = offer;
    this.def = def;
    this.customAppointmentLength = customAppointmentLength;
    this.price = price;
    this.kickback = kickback;
    this.idInsurer = idInsurer;

    var _typeContext = {
        pricelist : ResourcePriceListMeedyVO,
        offer : OfferMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
